/* 🤖 this file was generated by svg-to-ts */

export type PlIcon =
  | 'arrow_left'
  | 'badge_lifemap'
  | 'badge_self_discovery'
  | 'badge_strengths'
  | 'badge_time_to_reflect'
  | 'briefcase'
  | 'calendar_add'
  | 'calendar_mac'
  | 'calendar_outlook'
  | 'certificate_blue'
  | 'certificate_green'
  | 'chatbox_ellipses_outline'
  | 'check_inverted_circle'
  | 'chevron_back'
  | 'chevron_forward'
  | 'close'
  | 'exclamation'
  | 'eye_inverted_circle'
  | 'eye_off'
  | 'eye'
  | 'google'
  | 'heart_wind'
  | 'lock_inverted_circle'
  | 'lock'
  | 'log_out'
  | 'moon'
  | 'pause_circle'
  | 'pdf'
  | 'pen_to_square'
  | 'pl_logo'
  | 'play_circle'
  | 'star'
  | 'sun'
  | 'tick'
  | 'time'
  | 'verified'
  | 'video';
export const PlIcon = {
  arrow_left: 'arrow_left' as PlIcon,
  badge_lifemap: 'badge_lifemap' as PlIcon,
  badge_self_discovery: 'badge_self_discovery' as PlIcon,
  badge_strengths: 'badge_strengths' as PlIcon,
  badge_time_to_reflect: 'badge_time_to_reflect' as PlIcon,
  briefcase: 'briefcase' as PlIcon,
  calendar_add: 'calendar_add' as PlIcon,
  calendar_mac: 'calendar_mac' as PlIcon,
  calendar_outlook: 'calendar_outlook' as PlIcon,
  certificate_blue: 'certificate_blue' as PlIcon,
  certificate_green: 'certificate_green' as PlIcon,
  chatbox_ellipses_outline: 'chatbox_ellipses_outline' as PlIcon,
  check_inverted_circle: 'check_inverted_circle' as PlIcon,
  chevron_back: 'chevron_back' as PlIcon,
  chevron_forward: 'chevron_forward' as PlIcon,
  close: 'close' as PlIcon,
  exclamation: 'exclamation' as PlIcon,
  eye_inverted_circle: 'eye_inverted_circle' as PlIcon,
  eye_off: 'eye_off' as PlIcon,
  eye: 'eye' as PlIcon,
  google: 'google' as PlIcon,
  heart_wind: 'heart_wind' as PlIcon,
  lock_inverted_circle: 'lock_inverted_circle' as PlIcon,
  lock: 'lock' as PlIcon,
  log_out: 'log_out' as PlIcon,
  moon: 'moon' as PlIcon,
  pause_circle: 'pause_circle' as PlIcon,
  pdf: 'pdf' as PlIcon,
  pen_to_square: 'pen_to_square' as PlIcon,
  pl_logo: 'pl_logo' as PlIcon,
  play_circle: 'play_circle' as PlIcon,
  star: 'star' as PlIcon,
  sun: 'sun' as PlIcon,
  tick: 'tick' as PlIcon,
  time: 'time' as PlIcon,
  verified: 'verified' as PlIcon,
  video: 'video' as PlIcon,
};
export interface plIcon {
  name: PlIcon;
  data: string;
}
